// candle-intro.js

(function(){


//---------------------------------------------------------------------------
// node.js環境向けの対策
//---------------------------------------------------------------------------
var document = this.document;

var module = {exports:{}}, exports = module.exports;

(function(module,exports){
